export enum SurfaceQuality {
    FINELY_FINISHED = "FINELY_FINISHED",
    SETTLED = "SETTLED",
    ROUGHED = "ROUGHED",
  }
  